import { Grabber } from "./Grabber";
export async function loadExternalGrabInteraction(engine, refresh = true) {
    await engine.addInteractor("externalGrab", (container) => new Grabber(container), refresh);
}
export * from "./Options/Classes/Grab";
export * from "./Options/Classes/GrabLinks";
export * from "./Options/Interfaces/IGrab";
export * from "./Options/Interfaces/IGrabLinks";
